import { memo } from "react";

import { withT } from "neetocommons/react-utils";
import { Typography } from "neetoui";

const NoResults = withT(({ t }) => (
  <Typography
    className="neeto-ui-text-gray-400 flex h-64 items-center justify-center text-lg"
    data-testid="no-icon-results-found-text"
  >
    {t("neetoMolecules.iconPicker.dropdown.noResults")}
  </Typography>
));

export default memo(NoResults);
